document.addEventListener("DOMContentLoaded", function () {
    const redirectSellBaseUrl = window.location.origin + '/acheter-ou-vendre-un-vehicule/vendre-son-vehicule-presentation/';
    // Registration number form
    const $formHeroRegistrationNumber = document.querySelector('#sell-hero-form-registration-number');
    if ($formHeroRegistrationNumber) {
        const $formHeroRegistrationNumberInput = $formHeroRegistrationNumber.querySelector('#sell-hero-form-registration-number-input');
        if ($formHeroRegistrationNumberInput) {
            $formHeroRegistrationNumberInput.addEventListener('keyup', (event) => {
                let str = event.target.value;
                if (event.keyCode !== 8) {
                    str = str.toUpperCase(); // To uppercase
                    if (str.length === 2) {
                        str = str.replace(/[^a-zA-Z0-9 ]/g, '').replace(/([A-Z]{2})/, '$1-');
                    }
                    else if (str.length === 6) {
                        str = str.replace(/[^a-zA-Z0-9 ]/g, '').replace(/([A-Z0-9]{2})([A-Z0-9]{3})/, '$1-$2-');
                    }
                    else if (str.length > 8) {
                        str = str.slice(0, 9);
                    }
                }
                $formHeroRegistrationNumberInput.value = str.replace(/([A-Z]{2})([0-9]{3})([A-Z]{2})/, '$1-$2-$3');
            });
        }

        $formHeroRegistrationNumber.addEventListener('submit', (event) => {
            event.preventDefault();
            if ($formHeroRegistrationNumberInput.value !== '') {
                document.location.href = redirectSellBaseUrl+'?registration_number=' + $formHeroRegistrationNumberInput.value.replace(/[^a-zA-Z0-9 ]/g, '');
            }
        });
    }

    // Make select form
    const $formHeroMake = document.querySelector('#sell-hero-form-make');
    if ($formHeroMake) {
        const $formHeroMakeInput = $formHeroMake.querySelector('#sell-hero-form-make-input');
        const $formHeroMakeSuggestions = $formHeroMake.querySelector('#sell-hero-form-make-suggestions ul');
        if ($formHeroMakeInput && $formHeroMakeSuggestions) {
            const redirectWithMakeId = (makeId) => {
                document.location.href = redirectSellBaseUrl+'?make='+makeId;
            }

            const search = (str) => {
                let results = [];
                const val = str.toLowerCase();
            
                for (let i = 0; i < brands.length; i++) {
                    if (brands[i]['name'].toLowerCase().indexOf(val) > -1) {
                        results.push(brands[i]);
                    }
                }
            
                return results;
            }
            
            const searchHandler = (e) => {
                const inputVal = e.currentTarget.value;
                let results = [];
                if (inputVal.length > 0) {
                    results = search(inputVal);
                }
                showSuggestions(results, inputVal);
            }
            
            const showSuggestions = (results, inputVal) => {
                
                $formHeroMakeSuggestions.innerHTML = '';
            
                if (results.length > 0) {
                    for (let i = 0; i < results.length; i++) {
                        let brandName = results[i].name;
                        let brandId = results[i].id;
                        // Highlights only the first match
                        // TODO: highlight all matches
                        const match = brandName.match(new RegExp(inputVal, 'i'));
                        brandName = brandName.replace(match[0], `<strong>${match[0]}</strong>`);
                        $formHeroMakeSuggestions.innerHTML += `<li data-brand-id="${brandId}">${brandName}</li>`;
                    }
                    $formHeroMakeSuggestions.classList.add('has-suggestions');
                } else {
                    results = [];
                    $formHeroMakeSuggestions.innerHTML = '';
                    $formHeroMakeSuggestions.classList.remove('has-suggestions');
                }
            }
            
            const useSuggestion = (e) => {
                $formHeroMakeInput.value = e.target.innerText;
                $formHeroMakeInput.focus();
                $formHeroMakeSuggestions.innerHTML = '';
                $formHeroMakeSuggestions.classList.remove('has-suggestions');
                
                redirectWithMakeId(e.target.dataset.brandId);
            }

            // From autobiz makes list to reduce api calls (how to maintain this list ?)
            const brands = [{"id":355,"name":"ABARTH"},{"id":53,"name":"AIXAM"},{"id":54,"name":"ALFA ROMEO"},{"id":739,"name":"ALPINE"},{"id":212,"name":"ASTON MARTIN"},{"id":55,"name":"AUDI"},{"id":218,"name":"BENTLEY"},{"id":57,"name":"BMW"},{"id":166,"name":"CADILLAC"},{"id":360,"name":"CHATENET"},{"id":60,"name":"CHEVROLET"},{"id":58,"name":"CHRYSLER"},{"id":59,"name":"CITROEN"},{"id":764,"name":"CUPRA"},{"id":231,"name":"DACIA"},{"id":61,"name":"DAIHATSU"},{"id":241,"name":"DODGE"},{"id":619,"name":"DS AUTOMOBILES"},{"id":62,"name":"FERRARI"},{"id":63,"name":"FIAT"},{"id":557,"name":"FISKER"},{"id":64,"name":"FORD"},{"id":248,"name":"FORD USA"},{"id":66,"name":"HONDA"},{"id":174,"name":"HUMMER"},{"id":67,"name":"HYUNDAI"},{"id":263,"name":"INFINITI"},{"id":68,"name":"ISUZU"},{"id":172,"name":"IVECO"},{"id":69,"name":"JAGUAR"},{"id":95,"name":"JEEP"},{"id":162,"name":"KIA"},{"id":70,"name":"LADA"},{"id":269,"name":"LAMBORGHINI"},{"id":71,"name":"LANCIA"},{"id":72,"name":"LAND ROVER"},{"id":164,"name":"LEXUS"},{"id":73,"name":"LIGIER"},{"id":272,"name":"LOTUS"},{"id":805,"name":"LYNK CO"},{"id":74,"name":"MASERATI"},{"id":75,"name":"MAZDA"},{"id":555,"name":"MCLAREN"},{"id":76,"name":"MERCEDES"},{"id":77,"name":"MG"},{"id":327,"name":"MICROCAR"},{"id":167,"name":"MINI"},{"id":79,"name":"MITSUBISHI"},{"id":362,"name":"MITSUBISHI TRUCKS"},{"id":280,"name":"MORGAN"},{"id":80,"name":"NISSAN"},{"id":361,"name":"NISSAN TRUCKS"},{"id":81,"name":"OPEL"},{"id":82,"name":"PEUGEOT"},{"id":83,"name":"PORSCHE"},{"id":84,"name":"RENAULT"},{"id":342,"name":"RENAULT TRUCKS"},{"id":177,"name":"ROLLS ROYCE"},{"id":170,"name":"ROVER"},{"id":85,"name":"SAAB"},{"id":86,"name":"SEAT"},{"id":88,"name":"SKODA"},{"id":163,"name":"SMART"},{"id":175,"name":"SSANGYONG"},{"id":89,"name":"SUBARU"},{"id":90,"name":"SUZUKI"},{"id":368,"name":"TESLA"},{"id":91,"name":"TOYOTA"},{"id":92,"name":"VOLKSWAGEN"},{"id":94,"name":"VOLVO"}];

            $formHeroMakeInput.addEventListener('keyup', searchHandler);
            $formHeroMakeSuggestions.addEventListener('click', useSuggestion);
            
            $formHeroMake.addEventListener('submit', (event) => {
                event.preventDefault();
                if ($formHeroMakeInput.value !== '') {
                    const inputSearch = search($formHeroMakeInput.value);
                    if (inputSearch.length) {
                        redirectWithMakeId(inputSearch[0].id);
                    }
                }             
            });
        }
    }
});